import { Menu, LogOut, User } from 'lucide-react';
import { useAuthStore } from '@/modules/auth/authStore';
import { useAppTabsStore, createTabFromPath } from '@/stores/appTabsStore';

interface HeaderProps {
  onToggleSidebar: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps) {
  const { user, JabatanUserAktif, logout } = useAuthStore();
  const { openTab } = useAppTabsStore();

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  const handleOpenProfil = () => {
    openTab(createTabFromPath('/profil', 'Profil Saya', <User size={16} />));
  };

  return (
    <header className="app-header">
      <button className="header-toggle" onClick={onToggleSidebar} title="Toggle Menu">
        <Menu size={22} />
      </button>

      <div className="header-brand">
        <div className="header-logo">B</div>
        <div className="header-title-group">
          <span className="header-title">Booku</span>
          <span className="header-subtitle">Sistem Akuntansi Terpadu</span>
        </div>
      </div>

      <div className="header-spacer" />

      <div className="header-actions">
        {user && (
          <div className="header-user-info">
            <span className="header-user-name">{user.fullName || user.username}</span>
            <span className="header-user-role">{JabatanUserAktif}</span>
          </div>
        )}

        <button className="header-btn" onClick={handleOpenProfil} title="Profil">
          <User size={20} />
        </button>

        <button className="header-btn" onClick={handleLogout} title="Keluar">
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
}
